import React from 'react';
import ClearIcon from '@material-ui/icons/Clear';

import { Tabs, Button } from '../../common';

const Header = ({
  styles,
  tabs,
  value,
  onTabChange,
  onFilterClear,
  hasFilter,
}) => {
  return (
    <div className={styles['header']}>
      <Tabs
        className={styles['header__tabs']}
        iconClassName={styles['header__tabs-icon']}
        labelClassName={styles['header__tabs-label']}
        indicatorClassName={styles['header__tabs-selected-indicator']}
        selectedClassName={styles['header__tabs-selected']}
        flexContainerClassName={styles['header__tabs-container']}
        tabClassName={styles['header__tabs-tab']}
        value={value}
        onChange={onTabChange}
        options={tabs}
        translated
      />
      {hasFilter && (
        <Button
          onClick={onFilterClear}
          id="page.post-box.component.clear-filters.clear-button"
          variant="icon"
        >
          <ClearIcon />
        </Button>
      )}
    </div>
  );
};

export default Header;
